module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.$route.meta.title),
      expression: "$route.meta.title"
    }],
    staticClass: "forum"
  }, [_c('section', {
    staticClass: "banner-wrapper"
  }, [_c('el-carousel', {
    staticClass: "forum-banner-carousel",
    attrs: {
      "trigger": "click",
      "height": "460px"
    }
  }, _vm._l((_vm.bannerCarouselList), function(banner) {
    return _c('el-carousel-item', {
      key: banner.id,
      attrs: {
        "interval": 5000
      }
    }, [_c('div', {
      style: ({
        height: '100%',
        cursor: 'pointer',
        background: 'url(' + banner.img + ') no-repeat center center',
        backgroundSize: 'cover'
      }),
      attrs: {
        "src": banner.img
      },
      on: {
        "click": function($event) {
          return _vm.goActivity(banner)
        }
      }
    })])
  }), 1), _vm._v(" "), _c('ul', {
    staticClass: "banner-box"
  }, _vm._l((_vm.bannerContent), function(content) {
    return _c('li', {
      key: content.index,
      staticClass: "banner-item",
      on: {
        "click": function($event) {
          return _vm.goActivity(content)
        }
      }
    }, [_c('img', {
      staticClass: "icon",
      attrs: {
        "src": content.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "banner-info"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('p', {
      staticClass: "content"
    }, [_vm._v(_vm._s(content.content))])])])
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "recommend-qa"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "qa-wrapper"
  }, [_c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isQaLoading),
      expression: "isQaLoading"
    }],
    staticClass: "qa-content"
  }, _vm._l((_vm.qaList), function(qaItem, qaIdx) {
    return _c('li', {
      key: qaIdx,
      staticClass: "qa-item"
    }, [_c('div', {
      staticClass: "qa-left",
      on: {
        "click": function($event) {
          return _vm.goQuestionDetail(qaItem, true)
        }
      }
    }, [_c('p', {
      staticClass: "count"
    }, [_vm._v(_vm._s(qaItem.no_of_comment))]), _vm._v(" "), _c('p', [_vm._v("回复")])]), _vm._v(" "), _c('div', {
      staticClass: "qa-right"
    }, [_c('p', {
      staticClass: "title",
      on: {
        "click": function($event) {
          return _vm.goQuestionDetail(qaItem)
        }
      }
    }, [_vm._v(_vm._s(qaItem.title))]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, _vm._l((qaItem.tags), function(tag, tagIdx) {
      return _c('li', {
        key: tagIdx,
        on: {
          "click": function($event) {
            return _vm.goSearch(tag)
          }
        }
      }, [_vm._v("\n                                " + _vm._s(tag.title) + "\n                            ")])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "footer"
    }, [_c('div', {
      staticClass: "footer-item"
    }, [_c('i', {
      staticClass: "smart-icon view-icon"
    }), _vm._v("\n                                " + _vm._s(qaItem.no_of_views) + "\n                            ")]), _vm._v(" "), _c('div', {
      class: ['footer-item', {
        'is-active': qaItem.is_followed
      }],
      on: {
        "click": function($event) {
          return _vm.focusToggle(qaItem)
        }
      }
    }, [_c('i', {
      staticClass: "smart-icon follow-icon"
    }), _vm._v("\n                                " + _vm._s(qaItem.no_of_followed) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "footer-item",
      on: {
        "click": function($event) {
          return _vm.goHomePage(qaItem.created_by)
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "user-card",
        "placement": "top",
        "open-delay": 500,
        "width": "400",
        "trigger": "hover"
      },
      on: {
        "show": function($event) {
          _vm.$refs['card' + qaItem.created_by.id + qaIdx][0].getUserInfo()
        }
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right",
        "margin": "0, padding: 0"
      }
    }, [_c('user-card', {
      ref: ("card" + (qaItem.created_by.id) + qaIdx),
      refInFor: true,
      attrs: {
        "user-id": qaItem.created_by.id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "user-avatar",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [(!qaItem.created_by.user_logo || qaItem.created_by.user_logo.substr(0, 1) === '?') ? _c('img', {
      staticClass: "user-logo",
      attrs: {
        "src": require("../images/personal_center/avatar_default.png")
      }
    }) : _c('img', {
      staticClass: "user-logo",
      attrs: {
        "src": qaItem.created_by.user_logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(qaItem.created_by.nick_name))])])]), _vm._v(" "), (qaItem.created_by.is_official) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "蓝鲸智云官方",
        "placement": "right"
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-lanjingguanfang"
      }
    })])]) : _vm._e(), _vm._v(" "), (qaItem.created_by.is_vip) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "核心用户标识",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "icon-vipuser"
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v(_vm._s(_vm.getTime(qaItem.created_on)))])], 1)])])])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.goToDoc({
          url: '/s-mart/community/question'
        })
      }
    }
  }, [_c('span', [_vm._v("查看全部")]), _vm._v(" "), _c('i', {
    staticClass: "arrow-right-icon"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isActiveUserLoading),
      expression: "isActiveUserLoading"
    }],
    staticClass: "respondent-content"
  }, [_c('div', {
    staticClass: "active-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("活跃答主")]), _vm._v(" "), _c('div', {
    staticClass: "data-switch"
  }, _vm._l((_vm.switchData), function(item) {
    return _c('span', {
      key: item.type,
      class: ['switch-item', {
        'active': _vm.userRankBoard === item.type
      }],
      on: {
        "click": function($event) {
          _vm.userRankBoard = item.type
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.title) + "\n                        ")])
  }), 0)]), _vm._v(" "), (_vm.activeUserList.length) ? _c('ul', _vm._l((_vm.activeUserList), function(user, index) {
    return _c('li', {
      key: index,
      class: ['active-user-item', {
        'is-crown': index < 3
      }],
      on: {
        "click": function($event) {
          return _vm.goHomePage({
            user_id: user.id
          })
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "user-card",
        "placement": "top",
        "open-delay": 500,
        "width": "400",
        "trigger": "hover"
      },
      on: {
        "show": function($event) {
          _vm.$refs['card' + user.id + index][0].getUserInfo()
        }
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right",
        "margin": "0, padding: 0"
      }
    }, [_c('user-card', {
      ref: ("card" + (user.id) + index),
      refInFor: true,
      attrs: {
        "user-id": user.id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "user-avatar",
      attrs: {
        "slot": "reference"
      },
      on: {
        "click": function($event) {
          _vm.visible = !_vm.visible
        }
      },
      slot: "reference"
    }, [_c('div', {
      staticClass: "user-avatar"
    }, [(index === 0) ? _c('img', {
      attrs: {
        "height": "48px",
        "width": "37px",
        "src": require("../images/community/crown.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index === 1) ? _c('img', {
      attrs: {
        "height": "48px",
        "width": "37px",
        "src": require("../images/community/crown2.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (index === 2) ? _c('img', {
      attrs: {
        "height": "48px",
        "width": "37px",
        "src": require("../images/community/crown1.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (!user.user_avatar || user.user_avatar.substr(0, 1) === '?') ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": require("../images/personal_center/avatar_default.png")
      }
    }) : _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": user.user_avatar,
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "user-message"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('p', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.nickname))]), _vm._v(" "), (user.is_official) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "蓝鲸智云官方",
        "placement": "right"
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-lanjingguanfang"
      }
    })])]) : _vm._e(), _vm._v(" "), (user.is_vip) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "核心用户",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "icon-vipuser"
    })]) : _vm._e()], 1), _vm._v(" "), _c('p', {
      staticClass: "reply-info"
    }, [_vm._v("\n                                " + _vm._s(user.nums) + "\n                                "), _c('span', [_vm._v("个回答")])])]), _vm._v(" "), (user.is_followed !== null) ? _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "placement": "top",
        "content": user.is_followed ? '取消关注' : '添加关注'
      }
    }, [_c('div', {
      class: ['follow-btn', user.is_followed ? 'followed' : 'not-follow'],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleToggleAttention(user)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(user.is_followed ? '已关注' : '关注') + "\n                            ")])]) : _vm._e()], 1)
  }), 0) : _c('p', {
    staticClass: "data-null"
  }, [_vm._v("暂无数据")])])])]), _vm._v(" "), _c('section', {
    staticClass: "recommend-article"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "article-content"
  }, [_c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isArticleLoading),
      expression: "isArticleLoading"
    }],
    staticClass: "article-list"
  }, _vm._l((_vm.articleList), function(articleItem, articleIdx) {
    return _c('li', {
      key: articleIdx,
      staticClass: "article-item"
    }, [_c('p', {
      ref: "descHook",
      refInFor: true,
      staticClass: "question-desc img-hook",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": ("article-item-" + (articleItem.id))
      },
      domProps: {
        "innerHTML": _vm._s(_vm.filterXSS(articleItem.afterHtmlDesc))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "article-left"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      class: [articleItem.is_reprint ? 'reprint' : 'original']
    }, [_vm._v(_vm._s(articleItem.is_reprint ? '转载' : '原创'))]), _vm._v(" "), _c('p', {
      staticClass: "title",
      on: {
        "click": function($event) {
          return _vm.goArticleDetail(articleItem)
        }
      }
    }, [_vm._v(_vm._s(articleItem.title))])]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, _vm._l((articleItem.tags), function(tag, tagIdx) {
      return _c('li', {
        key: tagIdx,
        on: {
          "click": function($event) {
            return _vm.goSearch(tag)
          }
        }
      }, [_vm._v("\n                                " + _vm._s(tag.title) + "\n                            ")])
    }), 0), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(_vm.filterXSS(articleItem.descText))
      },
      on: {
        "click": function($event) {
          return _vm.goArticleDetail(articleItem)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "footer"
    }, [_c('div', {
      staticClass: "footer-item default"
    }, [_c('i', {
      staticClass: "smart-icon view-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "count"
    }, [_vm._v(_vm._s(articleItem.no_of_views))])]), _vm._v(" "), _c('div', {
      class: ['footer-item', {
        'is-active': articleItem.is_me_comment
      }],
      on: {
        "click": function($event) {
          return _vm.goArticleDetail(articleItem, true)
        }
      }
    }, [_c('i', {
      staticClass: "smart-icon comment-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "count"
    }, [_vm._v(_vm._s(articleItem.no_of_comment))])]), _vm._v(" "), _c('div', {
      class: ['footer-item', {
        'is-active': articleItem.is_vote_up
      }],
      on: {
        "click": function($event) {
          return _vm.onVoteToggle(articleItem)
        }
      }
    }, [_c('i', {
      staticClass: "smart-icon like-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "count"
    }, [_vm._v(_vm._s(articleItem.no_of_vote_up))])]), _vm._v(" "), _c('div', {
      class: ['footer-item', {
        'is-active': articleItem.is_liked
      }],
      on: {
        "click": function($event) {
          return _vm.favoriteToggle(articleItem)
        }
      }
    }, [_c('i', {
      staticClass: "smart-icon collect-icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "count"
    }, [_vm._v(_vm._s(articleItem.no_of_likes))])]), _vm._v(" "), _c('div', {
      staticClass: "footer-item default",
      on: {
        "click": function($event) {
          return _vm.goHomePage(articleItem.created_by)
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "user-card",
        "placement": "top",
        "open-delay": 500,
        "width": "400",
        "trigger": "hover"
      },
      on: {
        "show": function($event) {
          _vm.$refs['card' + articleItem.created_by.id + articleIdx][0].getUserInfo()
        }
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right",
        "margin": "0, padding: 0"
      }
    }, [_c('user-card', {
      ref: ("card" + (articleItem.created_by.id) + articleIdx),
      refInFor: true,
      attrs: {
        "user-id": articleItem.created_by.id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "user-avatar",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [(!articleItem.created_by.user_logo || articleItem.created_by.user_logo.substr(0, 1) === '?') ? _c('img', {
      staticClass: "user-logo",
      attrs: {
        "src": require("../images/personal_center/avatar_default.png")
      }
    }) : _c('img', {
      staticClass: "user-logo",
      attrs: {
        "src": articleItem.created_by.user_logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(articleItem.created_by.nick_name))])])]), _vm._v(" "), (articleItem.created_by.is_official) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "蓝鲸智云官方",
        "placement": "right"
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-lanjingguanfang"
      }
    })])]) : _vm._e(), _vm._v(" "), (articleItem.created_by.is_vip) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "核心用户",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "icon-vipuser"
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v(_vm._s(_vm.getTime(articleItem.created_on)))])], 1)])]), _vm._v(" "), (articleItem.imgSrc) ? _c('div', {
      staticClass: "article-right"
    }, [_c('img', {
      attrs: {
        "src": articleItem.imgSrc,
        "alt": ""
      }
    })]) : _vm._e()])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.goToDoc({
          url: '/s-mart/community/article'
        })
      }
    }
  }, [_vm._v("\n                查看全部\n                "), _c('i', {
    staticClass: "arrow-right-icon"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isArticleRankLoading),
      expression: "isArticleRankLoading"
    }],
    staticClass: "article-rank"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("文章排行")]), _vm._v(" "), _c('div', {
    staticClass: "data-switch"
  }, _vm._l((_vm.switchData), function(item) {
    return _c('span', {
      key: item.type,
      class: ['switch-item', {
        'active': _vm.articleRankBoard === item.type
      }],
      on: {
        "click": function($event) {
          _vm.articleRankBoard = item.type
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.title) + "\n                        ")])
  }), 0)]), _vm._v(" "), (_vm.articleRankList.length) ? _c('ul', _vm._l((_vm.articleRankList), function(article, index) {
    return _c('li', {
      key: index,
      class: ['rank-item', {
        'is-crown': index < 3
      }]
    }, [_c('div', {
      class: ['view-box', ("rank" + index)]
    }, [(index === 0) ? _c('img', {
      attrs: {
        "height": "13px",
        "src": require("../images/community/fire.png"),
        "alt": ""
      }
    }) : (index === 1) ? _c('img', {
      attrs: {
        "height": "13px",
        "src": require("../images/community/fire2.png"),
        "alt": ""
      }
    }) : (index === 2) ? _c('img', {
      attrs: {
        "height": "13px",
        "src": require("../images/community/fire1.png"),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "width": "16px",
        "src": require("../images/community/eye-open.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(article.no_of_views))])]), _vm._v(" "), _c('div', {}, [_c('p', {
      staticClass: "title",
      on: {
        "click": function($event) {
          return _vm.goArticleDetail(article)
        }
      }
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('el-popover', {
      attrs: {
        "popper-class": "user-card",
        "placement": "top",
        "open-delay": 500,
        "width": "400",
        "trigger": "hover"
      },
      on: {
        "show": function($event) {
          _vm.$refs['articleCard' + article.created_by.id + index][0].getUserInfo()
        }
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "right",
        "margin": "0, padding: 0"
      }
    }, [_c('user-card', {
      ref: ("articleCard" + (article.created_by.id) + index),
      refInFor: true,
      attrs: {
        "user-id": article.created_by.id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "user-name",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('span', {
      staticClass: "user-name",
      on: {
        "click": function($event) {
          return _vm.goHomePage(article.created_by)
        }
      }
    }, [_vm._v(_vm._s(article.created_by.nick_name))])])]), _vm._v(" "), (article.created_by.is_official) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "蓝鲸智云官方",
        "placement": "right"
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px",
        "vertical-align": "middle"
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-lanjingguanfang"
      }
    })])]) : _vm._e(), _vm._v(" "), (article.created_by.is_vip) ? _c('el-tooltip', {
      attrs: {
        "effect": "light",
        "content": "核心用户",
        "placement": "right"
      }
    }, [_c('span', {
      staticClass: "icon-vipuser"
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "art_nums"
    }, [_vm._v(_vm._s(article.created_by.article_num) + "篇文章")])], 1)])
  }), 0) : _c('p', {
    staticClass: "data-null"
  }, [_vm._v("暂无数据")])])])]), _vm._v(" "), _c('section', {
    staticClass: "course-study"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../images/community/study.png"),
      "alt": ""
    }
  }), _vm._v("\n            课程学习\n            "), _c('span', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.goToDoc({
          url: 'https://bk.tencent.com/docs/video/6.0',
          isCloud: true
        }, true)
      }
    }
  }, [_vm._v("更多 >")])]), _vm._v(" "), _c('div', {
    staticClass: "course-wrapper"
  }, [_c('el-carousel', {
    staticClass: "course-carousel",
    attrs: {
      "trigger": "click",
      "height": "260px",
      "interval": 6000
    }
  }, _vm._l((_vm.courseList), function(course, index) {
    return _c('el-carousel-item', {
      key: index
    }, _vm._l((course), function(item) {
      return _c('div', {
        key: item.name,
        staticClass: "course-item",
        on: {
          "click": function($event) {
            return _vm.handleVideoPreview(item)
          }
        }
      }, [_c('div', {
        staticClass: "img"
      }), _vm._v(" "), _c('div', {
        staticClass: "mask"
      }, [_c('div', {
        staticClass: "play-btn"
      })]), _vm._v(" "), _c('div', {
        staticClass: "topic"
      }, [_vm._v("BlueKing")]), _vm._v(" "), _c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
        staticClass: "duration"
      }, [_vm._v(_vm._s(item.desc))])])
    }), 0)
  }), 1)], 1)]), _vm._v(" "), _c('section', {
    staticClass: "hot-download"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../images/community/download.png"),
      "alt": ""
    }
  }), _vm._v("\n            热门下载\n            "), _c('span', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.goToDoc({
          url: '/download/'
        }, true)
      }
    }
  }, [_vm._v("更多 >")])]), _vm._v(" "), _c('ul', {
    staticClass: "download-wrapper"
  }, _vm._l((_vm.downloadList), function(info, index) {
    return _c('li', {
      key: index,
      staticClass: "download-item",
      on: {
        "click": function($event) {
          return _vm.goToDoc({
            url: 'https://bk.tencent.com/s-mart/downloads?type=packageDown&version=binary',
            isCloud: true
          }, true)
        }
      }
    }, [_c('div', {
      class: ['label', {
        'required': info.required
      }]
    }, [_vm._v(_vm._s(info.required ? '必备' : '可选'))]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(info.title))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(info.desc))]), _vm._v(" "), _c('div', {
      staticClass: "version"
    }, [_c('span', [_vm._v(_vm._s(info.version))]), _vm._v(" "), _c('img', {
      attrs: {
        "height": "24px",
        "width": "24px",
        "src": require("../images/community/donwload2.png"),
        "alt": ""
      }
    })])])
  }), 0)]), _vm._v(" "), _c('section', {
    staticClass: "community-edition"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("在线体验")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("完全免费，所见即所得的在线体验环境。抢先体验，蓝鲸产品新功能曝光的前哨站。场景丰富，内置各行业经典案例和高级用法，并有合作伙伴提供的优质SaaS")]), _vm._v(" "), _c('div', {
    staticClass: "experience-btn",
    on: {
      "click": _vm.handleOnlineExperience
    }
  }, [_vm._v("\n            立即体验\n        ")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShow,
      "center": "",
      "close-on-click-modal": false,
      "destroy-on-close": true,
      "custom-class": "docs-video-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShow = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "src": _vm.videoUrl,
      "autoplay": "",
      "controls": ""
    }
  }, [_vm._v("\n            抱歉，您的浏览器不支持内嵌视频，不过不用担心，你可以 "), _c('a', {
    attrs: {
      "href": _vm.videoUrl
    }
  }, [_vm._v("下载")]), _vm._v("\n            并用你喜欢的播放器观看!\n        ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../images/community/qa.png"),
      "alt": ""
    }
  }), _vm._v("\n            推荐问答\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../images/community/article.png"),
      "alt": ""
    }
  }), _vm._v("\n            推荐文章\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9218d156!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/forum.vue
// module id = sJCv
// module chunks = 15